// store/forms/delForm/misc/delFormMiscActions.js

/**
 * Creates actions for the Misc tab in the DEL form
 * @param {object} api - The api object containing getDraft, bump, and setMiscUi helpers
 * @returns {object} Frozen object containing misc tab actions
 */
export const makeMiscActions = (api) => ({
  /**
   * Sets the active sub-tab within the Misc tab
   * @param {string} tabName - "photos" | "wasteDisposal" | "clientSignatures"
   */
  setActiveMiscTab: (tabName) => {
    api.setMiscUi({ activeMiscTab: tabName });
  },
});